export default {"src":"/_next/static/media/premium_black.a4e2d175.svg","height":15,"width":16};